import { Component, OnInit } from '@angular/core';
import { MetaService } from 'services/meta.service';

@Component({
	selector: 'ras-wrong-route-page',
	templateUrl: './wrong-route-page.component.html',
	styleUrls: ['./wrong-route-page.component.sass']
})
export class WrongRoutePageComponent implements OnInit {

	constructor(private metaService: MetaService) { }

	ngOnInit() {
		this.metaService.apply('404')
	}

}
